import { SpinAndHoldCommonConfiguration } from "../../../api";
import { Resourceful2 } from "../../../ResourceManager/Resourceful";
import { ChangeSpeedParams } from "../../SlotGameType1";
import { SpinAndHoldBonus } from "../SpinAndHold/SpinAndHold";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";

// enum BigSymbolSpinAndHoldRecoveryAction = SpinAndHoldRecoveryAction &
// {
// 	BigSymbolSpinAndHoldSpin = "BigSymbolSpinAndHoldSpin",
// 	BigSymbolSpinAndHoldStart = "BigSymbolSpinAndHoldStart"
// }
export class BigSymbolSpinAndHoldBonus extends SpinAndHoldBonus implements Resourceful2 {
	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		throw new Error("Method not implemented.");
	}
	
	protected override BonusName(): string
	{
		return "BigSymbolSpinAndHold";
	}

	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params, config);
	}
}



